module.exports = __webpack_public_path__ + "static/media/logo-light.1ffb892d.svg";